import { ComponentProps } from "react";

interface GHSLogoProps extends Omit<ComponentProps<"img">, "src" | "alt"> {
  className?: string;
}

export function GHSLogo({ width = 32, height = 32, className, ...rest }: GHSLogoProps) {
  return (
    <img
      src="/images/logos/GHS.png"
      alt="GHS Logo"
      width={Number(width)}
      height={Number(height)}
      className={className}
      {...(rest as any)}
    />
  );
}
